export default {
  help: {
    id: 'insurance_policy_details_help_button',
    defaultMessage: 'Get help',
  },
  cancel: {
    id: 'insurance_policy_details_cancel_button',
    defaultMessage: 'Cancel plan',
  },
  cancelDisabledExplanation: {
    id: 'insurance_policy_details_cancel_button_disabled_explanation',
    defaultMessage: 'You cannot cancel your plan at this time.',
  },
}
